import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const RightContentContainer = styled.div`
  // display: grid;
  // grid-template-columns: 1fr 1fr;
  margin-top: 200px;
`;

export const InnerLeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 50px;
`;
export const ReverseOnMobile = styled.div`
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column-reverse;
  }
`;
export const InnerRightContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-items: flex-start;
  margin-right: 135px;
`;

export const ImageContainer = styled.img`
  /* width: 742px; */
  height: 100vh;
  @media (max-width: 768px) {
    margin: 0px;
    height: auto;
    width: 100%;
    border-radius: 20px;
  }
`;
export const ImageContainer3 = styled.img`
  /* width: 742px; */
  height: 100vh;
  margin-top: -110px;
  @media (max-width: 768px) {
    margin: 0px;
    height: auto;
    width: 100%;
    border-radius: 20px;
  }
`;

export const Name = styled.h3`
  font-family: Poppins-Regular;
  color: #1d1d1d;
  line-height: 41px;
  margin-top: 29px;
  @media (max-width: 786px) {
    line-height: 25px;
    margin-top: 10px;
  }
`;
export const Position = styled.h3`
  font-family: Poppins-Light;
  color: #8d8d8d;
  line-height: 41px;
  @media (max-width: 786px) {
    line-height: 14px;
  }
`;

export const Heading = styled.h3`
  font-family: Poppins-Regular;
  color: #1d1d1d;
  line-height: 41px;
  padding-top: 50px;
  @media (max-width: 786px) {
    text-align: center;
    line-height: 21px;
    padding-top: 30px;
  }
`;

export const DescriptionContainer = styled.p`
  font-size: 18px;
  font-family: Poppins-Light;
  color: #1d1d1d;
  line-height: 25px;
`;

export const LeftContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const InnerContainerLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-items: flex-start;
  padding-left: 113px;
`;

export const InnerContainerRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 113px;
`;

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;
`;

export const InnerTopContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Heading2 = styled.h2`
  font-size: 42px;
  font-family: Poppins-SemiBold;
  color: #1d1d1d;
  text-align: center;

  @media (max-width: 768px) {
    line-height: 50px;
    margin-top: 20px;
  }
`;

export const Description = styled.p`
  font-size: 28px;
  font-family: Poppins-Light;
  color: #1d1d1d;
  line-height: 50px;
  margin: unset;
  text-align: center;
  align-self: center;
  @media (max-width: 768px) {
    line-height: 30px;
  }
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 100px;
  width: 100%;
  margin-bottom: 100px;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
`;

export const Card = styled.div`
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 10px;
  opacity: 1;
  position: relative;
`;

export const ImageContainer2 = styled.img`
  height: 60vh;
  width: 50vh;

  @media (max-width: 786px) {
    border-radius: 15px;
  }
`;

export const InformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  position: absolute;
  bottom: 0px;
  height: auto;
  width: 100%;
  padding: 20px;
  padding-left: 0px;
  @media (max-width: 786px) {
    max-width: fit-content !important;
    padding: 20px;
    padding-left: 0px;
  }
`;
export const InnerName = styled.h4`
  font-size: 22px;
  font-family: Poppins-Light;
  font-weight: 600;
  color: #1d1d1d;

  @media (max-width: 786px) {
  }
`;
export const InnerPosition = styled.p`
  font-size: 17px;
  font-family: Poppins-ExtraLight;
  color: #a9a9a9;
  text-align: center;
  font-weight: 900;

`;

export const Arrow = styled.div`
  width: 120px;
  margin-top: 14px;
  width: 90px;
  background: blue;
  height: 10px;
  float: left;
  width: 0;
  height: 0;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  border-left: 30px solid blue;
  float: right;
`;

export const AboutContainer = styled.p`
  padding: 50px 150px 0px 150px;
  @media (max-width: 786px) {
    /* max-width: fit-content !important; */
    padding: unset;
  }
`;
